import { SUPPORTED_LOCALES } from '../../../../modules/i18n/config'
import { customPurpose, purposeItems } from './content'

// type Locale = 'ko' | 'en' | 'ja'

export type Locale = (typeof SUPPORTED_LOCALES)[number]

const getLocalizedName = (
  items: { id: number; value: string; value_en?: string; value_ja?: string }[],
  id: number,
  locale: Locale = 'en'
): string | undefined => {
  const item = items.find((x) => x.id === id)
  if (!item) return undefined

  switch (locale) {
    case 'ko':
      return item.value
    case 'ja':
      return item.value_ja
    case 'en':
    default:
      return item.value_en
  }
}

const getLocalizedNameForItem = (item: any, locale: Locale = 'en'): string | undefined => {
  // const item = items.find((x) => x.id === id)
  // if (!item) return undefined

  switch (locale) {
    case 'ko':
      return item.value
    case 'ja':
      return item.value_ja
    case 'en':
    default:
      return item.value_en
  }
}

export const getPurposeName = (id: number, locale: Locale) => getLocalizedName(purposeItems, id, locale)
export const getCustomPurpose = (locale: Locale) => getLocalizedNameForItem(customPurpose, locale)
